(function () {
    angular.module('app')
        .filter('videoEnableJs', videoEnableJs);

    videoEnableJs.$inject = [];
    function videoEnableJs() {
        return function (markup, provider, id) {
            switch (provider) {
                case "YouTube":
                    return markup.replace("?", "?enablejsapi=1&origin=" + location.origin + "&").replace("<iframe", "<iframe id=\"" + id + "\"");
                case "Vimeo":
                    return markup;
                case "Wistia, Inc.":
                    return markup.replace("class=\"wistia_embed", "id=\"" + id + "\" class=\"wistia_embed");
            }
            return markup;
        };
    }
})();